export function darkenRgba(rgbaString, amount = 0.52) {
  const match = rgbaString.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([0-9.]+))?\)/);

  if (!match) {
    throw new Error('Invalid RGBA string format');
  }

  let [_, r, g, b, a] = match;
  r = Math.max(0, Math.floor(parseInt(r) * (1 - amount)));
  g = Math.max(0, Math.floor(parseInt(g) * (1 - amount)));
  b = Math.max(0, Math.floor(parseInt(b) * (1 - amount)));
  a = a !== undefined ? parseFloat(a) : 1;

  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
